export default "__VITE_ASSET__v67zP48Q__"